import { ProfileHistoryWidget, SettingsWidget } from '@widgets/desktop';

interface ProfileRightContainerProps {
  page: string;
}

export const ProfileRightContainer = ({ page }: ProfileRightContainerProps) => {
  return page === 'account' ? <SettingsWidget /> : <ProfileHistoryWidget />;
};
